<template>
  <div class="head-member">
    <div class="x-banner">
      <slot></slot>
    </div>
    <div
      class="m-pf animateMe mt-5 profile-section"
      data-animation="fadeInUp"
    >
      <div class="img">
        <!-- <img
          src="@/assets/v3/profile/profile.png"
          alt=""
        /> -->
      </div>
      <div v-if="userProfile.stucked_voucher_id && promotions.length">
        <card-promotion 
          class="card-promotion" 
          :item="promotions[0]"
        >
        </card-promotion>
      </div>
    </div>
    

    <div
      class="m-rw animateMe"
      data-animation="fadeInUp"
    >
      <h5 class="">
        {{ $t('credit-balance') }}
      </h5>

      <h5 class="t-medium">
        ฿ {{ wallet.amount }}
      </h5>
    </div>

    <div class="m-btn">
      <div
        class="w-100 d-flex animateMe links"
        data-animation="fadeInUp"
        @click="goToDeposit"
      >
        <div
          class="btn-m dps w-100"
          :class="{'btn-member--cci': isCherdchai}"
        >
          <div class="img d-flex">
            <img
              v-if="isLottoslot88"
              src="@/assets/v3/icon-c-depos-ls.png"
              alt=""
            />
            <img
              v-else
              src="@/assets/v3/icon-c-depos.png"
              alt=""
            />
          </div>
          {{ $t('add-credit') }}
        </div>
      </div>
      <div
        v-if="promotions.length"
        class="w-100 d-flex animateMe links"
        data-animation="fadeInUp"
        @click="openDialogPromotion"
      >
        <div
          class="btn-m dps w-100"
        >
          <div class="img d-flex">
            <img
              src="@/assets/v3/icon-c-depos.png"
              alt=""
            />
          </div>
          {{ $t('add-credit-with-promotion') }}
        </div>
      </div>
      <div
        class="w-100 d-flex animateMe links"
        data-animation="fadeInUp"
        @click="goToWithdraw"
      >
        <div
          class="btn-m wd w-100"
          :class="{'btn-member--cci': isCherdchai}"
        >
          <div class="img d-flex">
            <img
              v-if="isLottoslot88"
              src="@/assets/v3/icon-c-withdraw-ls.png"
              alt=""
            />
            <img
              v-else
              src="@/assets/v3/icon-c-withdraw.png"
              alt=""
            />
          </div>
          {{ $t('title.withdraw') }}
        </div>
      </div>
    </div>
    <dialog-promotion ref="dialogPromotionRef"></dialog-promotion>
    <dialog-promotion-lock ref="dialogPromotionLockRef"></dialog-promotion-lock>
  </div>
</template>
<script>
import { vouchers as apiVouchers  } from '@/apis'  
import { ROUTE_DEPOSIT, ROUTE_WITHDRAW } from '@/const/route'
import CardPromotion from '@/components/Promotion/CardPromotion'
import DialogPromotion from '@/views-v2/Index/child/DialogPromotion'
import DialogPromotionLock from '@/components/Promotion/DialogPromotionLock'

export default {  
  components : {
    DialogPromotion,
    DialogPromotionLock,
    CardPromotion,
  },

  data: () => ({
    promotions: [],
  }), 
  computed : { 
    ROUTE_DEPOSIT: () => ROUTE_DEPOSIT,
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },

  async mounted () {     
    await this.getVouchers();
  },   

  methods: {
    async getVouchers () {  
      const [,data,,] = await apiVouchers.list({'type': 'turnover'})

      this.promotions = data
    },

    goToWithdraw () {

      if (this.userProfile.stucked_voucher_id) {
        this.$refs.dialogPromotionLockRef.open()
        return
      }

      this.$router.push({
        name: ROUTE_WITHDRAW
      })
    },

    goToDeposit () {

      if (this.userProfile.stucked_voucher_id) {
        this.$refs.dialogPromotionLockRef.open()
        return
      }

      this.$router.push({
        name: ROUTE_DEPOSIT
      })
    },

    openDialogPromotion () {

      if (this.userProfile.stucked_voucher_id) {
        this.$refs.dialogPromotionLockRef.open()
        return
      }

      this.$refs.dialogPromotionRef.open(this.promotions);
    },
  }
}
</script>
<style scoped>
.head-member {
  margin: 0 auto;
  padding: 30px 2% 120px 2%;
  position: relative;
  z-index: 2;
  border-radius: 0 0 50px 50px;
  background-color: var(--v3-sec-color-10);
  min-height: 120px;
  /* background: #488ef8; */
  /* background: linear-gradient(0deg, #488ef8 30%, rgba(106, 176, 248, 0) 100%); */
}
.head-member .m-pf {
  display: flex;
  align-items: center;
}
.head-member .m-pf .img {
  width: 160px;
}
.head-member .m-pf .txt {
  padding: 20px;
}
.head-member .m-rw {
  width: 600px;
  position: absolute;
  left: 0;
  bottom: 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, var(--v3-bar-color-15) 0%, var(--v3-bar-color-5) 100%);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 10px 2rem;
  border-radius: 0 10px 10px 0;
  color: var(--main-font-color);
}
.head-member .m-btn {
  width: 250px;
  position: absolute;
  z-index: 1;
  right: 10%;
  top: 50%;
  transform: translate(0%, -50%);
}
.head-member .m-btn .btn-m {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  padding: 10px 15px;
  margin: 10px;
  color: #fff;
  font-size: 20px;
  transition: all 0.3s;
}
.head-member .m-btn .btn-m .img {
  width: 40px;
  margin-right: 10px;
}
.head-member .m-btn .btn-m:hover {
  transform: scale(1.02);
}
.head-member .m-btn .btn-m.dps {
  background: linear-gradient(90deg, var(--v3-bar-color-15) 0%, var(--v3-bar-color-5) 100%);
  color: var(--main-font-color);
}
.head-member .m-btn .btn-m.wd {
  background: linear-gradient(90deg, var(--v3-bar-color-15) 0%, var(--v3-bar-color-5) 100%);
  color: var(--main-font-color);
}

.card-promotion {
  border: 3px;
  border-style: solid;
  border-color: white;
}

.profile-section {
  gap: 12px;
}

@media only screen and (max-width: 1200px) {
  .card-promotion {
    width: 40vw;
  }
}

@media only screen and (max-width: 992px) {
  .card-promotion {
    width: 100%;
  }

  .head_main {
    height: 87px;
  }
  .content_main {
    min-height: calc(100vh - 87px);
  }
  .nav-pills-bank {
    width: 100%;
  }
  .head-member .m-btn {
    width: 100%;
    padding: 0 5%;
    right: 0;
    top: 100%;
    display: flex;
    align-items: center;
  }

  .head-member .m-pf .img {
    width: 120px;
  }

  .head-member .m-btn .btn-m {
    font-size: 16px;
    padding: 10px 5px;
    margin: 5px;
  }
  .head-member .m-btn .btn-m .img {
    width: 30px;
    margin-right: 5px;
  }
  .head-member .m-rw {
    bottom: 50px;
  }
  .pt-content {
    padding-top: 80px;
  }
  .splide_card {
    width: 100%;
  }
  .splide_card .splide__slide.is-active .box_card {
    height: 170px;
  }
  .splide_card .box_card {
    height: 130px;
  }
}
@media only screen and (max-width: 767px) {
  .head-member .m-rw {
    width: 95%;
    bottom: 40px;
    padding: 10px 1rem;
  }
}

@media only screen and (max-width: 450px) {
  .head-member {
    margin: 0 auto;
    padding: 30px 1% 80px 1%;
  }

  .profile-section {
    flex-direction: column;
  }
}

img {
  width: 100%;
}

.d-flex {
  display: flex;
}

.w-100 {
  width: 100%;
}

.links:hover {
  cursor: pointer;
}

.x-banner {
  width: 100%;
}

.btn-member--cci {
  background: linear-gradient(
    to bottom,
    var(--v3-footer-color-15) 0%,
    var(--v3-footer-color-10) 100%
  ) !important;
}

@media only screen and (min-width: 992px) {
  .x-banner {
    width: 65%;
  }
}

</style>